import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common'
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {SharedModule} from "../../shared/shared.module";
import {BrowserModule} from "@angular/platform-browser";
import {IncludedPipe, InsuranceEditComponent} from "./insurance-edit.component";
import {InsuranceRoutingModule} from "./insurance-routing.module";

@NgModule({
    imports: [CommonModule,BrowserModule, FormsModule, ReactiveFormsModule, TranslateModule,
        SharedModule, InsuranceRoutingModule],
    declarations: [
        InsuranceEditComponent, IncludedPipe
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class InsuranceModule {}


// WEBPACK FOOTER //
// ./public/upgrade/feature/insurance/insurance.module.ts